
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurDoctors",
  data: () => ({
    teams: [
      {
        id: 1,
        datadelay: "300",
        image: require("../../assets/images/team/assistent-2.jpg"),
        name: "Elena",
        designation: "Asistent medical",
      },
      {
        id: 2,
        datadelay: "200",
        image: require("../../assets/images/team/assistent-1.jpg"),
        name: "Madalina",
        designation: "Asistent medical",
      },
     /* {
        id: 3,
        datadelay: "200",
        image: require("../../assets/images/team/assistent-3.jpg"),
        name: "Cristina Tiron",
        designation: "Asistent medical",
      },*/
    ],
  }),
});
